const BlockedUserGuard = (state) => {
  return {
    passedGuard: !state.user.userDetails?.blocked,
    redirectIfFail: "/blocked",
  };
};

export default BlockedUserGuard;
